import axios from 'src/utils/axios'
import { URLS } from 'src/utils/url'

class HomesetService {

	create(){	
		return alert("da sviluppare");
	}

	read() {
		return alert("da sviluppare");
	}

	update() {
		return alert("da sviluppare");
	}

	delete() {
		return alert("da sviluppare");
	}

	getAll(communityId) {
		return axios.get(`${URLS.COMMUNITY}/${communityId}/homeset`);
	}
}

const homesetService = new HomesetService();

export default homesetService;